import {matchPath} from 'react-router';

const getIn = (state, path) => {
    if (!state) {
        return state;
    }

    const length = path.length;
    if (!length) {
        return undefined;
    }

    let result = state;
    for (let i = 0; i < length && !!result; ++i) {
        result = result[path[i]];
    }

    return result;
};

export const createSelectors = () => {
    const isRouter = (value) =>
        value !== null && typeof value === 'object' && getIn(value, ['location']) && getIn(value, ['action']);

    const getRouter = (state) => {
        const router = getIn(state, ['router']);
        if (!isRouter(router)) {
            throw new Error('Could not find router reducer in state tree, it must be mounted under "router"');
        }
        return router;
    };
    const getLocation = (state) => getIn(getRouter(state), ['location']);
    const getAction = (state) => getIn(getRouter(state), ['action']);
    const getSearch = (state) => getIn(getRouter(state), ['location', 'search']);
    const getHash = (state) => getIn(getRouter(state), ['location', 'hash']);

    // It only makes sense to recalculate the `matchPath` whenever the pathname
    // of the location changes. That's why `createMatchSelector` memoizes
    // the latest result based on the location's pathname.
    const createMatchSelector = (path) => {
        let lastPathname = null;
        let lastMatch = null;

        return (state) => {
            const {pathname} = getLocation(state) || {};
            if (pathname === lastPathname) {
                return lastMatch;
            }
            lastPathname = pathname;
            const match = matchPath(pathname, path);
            if (
                !match ||
                !lastMatch ||
                match.url !== lastMatch.url ||
                // When URL matched for nested routes, URL is the same but isExact is not.
                match.isExact !== lastMatch.isExact
            ) {
                lastMatch = match;
            }

            return lastMatch;
        };
    };

    return {
        getLocation,
        getAction,
        getRouter,
        getSearch,
        getHash,
        createMatchSelector,
    };
};
